export default function normalizeString(str: string) {
    if (!str) {
        return '';
    }
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function normalizeCityName(value: string): string {
    if (!value) return '';

    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/['’`´-]/g, ' ')
        .trim()
        .toUpperCase();
}
